import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ProductMovePack } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class ProductMovePackService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getProductMovePack(id): Promise<ProductMovePack> {
    return new ProductMovePack(
      await this.core.services.productMovePack.getById(id, {
        // todo
        id: null,
      })
    )
  }

  async getProductMovePacks(
    // todo
    parameters: any = {
      page: 1,
      sort: 'id',
      direction: 'asc',
    },
    schema: any = { id: null }
  ): Promise<{
    items: ProductMovePack[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.productMovePack.getList(parameters, schema)
  }

  // createCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {
  //     return this.core.services.checkout.createWithTanstack(checkout, schema)
  // }

  // updateCheckout(checkout: Partial<Checkout>, schema: Checkout): Promise<Checkout> {y
  //     return this.core.services.checkout.updateWithTanstack(checkout, schema)
  // }

  // deleteProductMovePack(productMovePack: Partial<ProductMovePack>): Promise<ProductMovePack> {todo
  //   return this.core.services.productMovePack.dele(ProductMovePack)
  // }
}
